import { BaseQueryFn } from "@reduxjs/toolkit/query";
import axiosInstance from "./api";
import { AxiosError, InternalAxiosRequestConfig } from "axios";

export interface ApiErrorResponse {
  detail: string;
  status: number;
  title: string;
}

const axiosBaseQuery =
  (
    { baseUrl }: { baseUrl: string } = { baseUrl: "" },
  ): BaseQueryFn<
    {
      url: string;
      method: InternalAxiosRequestConfig["method"];
      data?: InternalAxiosRequestConfig["data"];
      params?: InternalAxiosRequestConfig["params"];
      headers?: InternalAxiosRequestConfig["headers"];
    },
    unknown,
    { detail: string; title: string }
  > =>
  async ({ url, method, data, params, headers }) => {
    try {
      const response = await axiosInstance({
        url: baseUrl + url,
        method,
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        data,
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        params,
        headers,
        timeout: 10000,
      });

      return response.data ? response.data : { data: null };
    } catch (axiosError) {
      const error = axiosError as AxiosError<ApiErrorResponse>;
      return {
        error: {
          detail: error.response?.data.detail,
          title: error.response?.data.title,
          status: error.response?.data.status,
        },
      };
      // console.error(axiosError);
      // throw axiosError;
    }
  };

export default axiosBaseQuery;
